// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"176":"projects","783":"sites","1160":"workspaces","1189":"editor","6842":"map","6865":"legacySearch"}[chunkId] || chunkId) + "." + {"176":"68e0c48f","783":"6497c672","1160":"68e0c48f","1189":"9c99e737","2912":"ba0e9403","6842":"58c8092e","6865":"58c8092e"}[chunkId] + ".css";
};